import { useCreateConversation } from "@/api/hooks/use-create-conversation";
import { useTemporaryChatStore } from "../store/temporary-chat-store";

export const useTemporaryChat = () => {
  // Store hooks
  const {
    isTemporaryMode,
    enableTemporaryMode,
    disableTemporaryMode,
    reset,
    setDidShowInfoModal,
  } = useTemporaryChatStore();

  // API hook
  const { createConversation, isCreating, error, data } =
    useCreateConversation();

  // Actions
  const handleToggleTemporaryMode = () => {
    if (isTemporaryMode) {
      // Eğer temporary mode açıksa, direkt kapat
      disableTemporaryMode();
      setDidShowInfoModal(false);
    } else {
      // Eğer temporary mode kapalıysa, direkt aç
      enableTemporaryMode();
    }
  };

  const handleConfirmTemporaryMode = () => {
    enableTemporaryMode();
  };

  const handleDisableTemporaryMode = () => {
    disableTemporaryMode();
  };

  const handleCreateTemporaryConversation = async (
    platform: string,
    initialMessage?: string
  ) => {
    try {
      const response = await createConversation({
        platform,
        initialMessage,
        isTemporary: true, // Temporary flag
      });
      return response;
    } catch (errorResponse: any) {
      console.error("Temporary conversation creation error:", errorResponse);
      throw errorResponse;
    }
  };

  const handleReset = () => {
    reset();
  };

  return {
    // State
    isTemporaryMode,
    isCreating,
    error,
    data,

    // Actions
    handleToggleTemporaryMode,
    handleConfirmTemporaryMode,
    handleDisableTemporaryMode,
    handleCreateTemporaryConversation,
    handleReset,
  };
};
